/**
 * External dependencies
 */
import jQuery from 'jquery';
import { SetButtonDisabled } from './utils';
jQuery( document ).ready( function ( $ ) {
	let startSel = null,
		endSel = null;
	$( '.wc-bookings-booking-form' )
		.closest( 'form' )
		.each( ( index, form ) => {
			const $form = $( form );
			if ( $form.find( '.picker' ).data( 'is_range_picker_enabled' ) ) {
				$form.find( 'p.wc_bookings_field_duration' ).hide();
			}
		} );
	$( '.block-picker' ).on( 'click', 'a', function () {
		const bookingform = $( this ).closest( 'form' );

		// Enable this event for month duration only to prevent unwanted ajax calls.
		if (
			! bookingform.find(
				'[name="wc_bookings_field_start_date_yearmonth"]'
			).length
		) {
			return false;
		}
		const $picker = bookingform.find( '.picker' );
		let value = $( this ).data( 'value' );
		const target = $( this ).closest( 'div' ).find( 'input' );
		let range;
		const blockPicker = $( this ).closest( 'ul' );
		setSelectedMonth( blockPicker, value );
		if ( ! $picker.data( 'is_range_picker_enabled' ) ) {
			// If we are not using range picker just trigger change for AJAX request.
			target.val( value ).trigger( 'change' );
			return;
		}

		// Unselect everything and set duration to default value.
		$( this ).parent().siblings().children( 'a' ).removeClass( 'selected' );
		$( '#wc_bookings_field_duration' ).val( 1 );
		if ( startSel && endSel ) {
			// If we have both start and end selection, reset end.
			startSel = $( this ).parent();
			endSel = null;
		} else if ( startSel ) {
			value = startSel.find( 'a' ).data( 'value' );
			// If we have start selection, we set end selection and do calculation.
			endSel = $( this ).parent();
			if ( startSel.is( endSel ) ) {
				// Not a range, just a single entry.
				range = startSel;
			} else {
				// There is a range so select every entry inclusive.
				range = startSel.nextUntil( endSel ).addBack();
				range = range.add( range.last().next() );
			}
			range.children( 'a' ).addClass( 'selected' );

			// Set duration and date and trigger change for AJAX request.
			$( '#wc_bookings_field_duration' ).val( range.length );
		} else {
			startSel = $( this ).parent();
		}
		target.val( value ).trigger( 'change' );
	} );
	let maxWidth = 0;
	let maxHeight = 0;
	$( '.block-picker a' ).each( function () {
		const width = $( this ).width();
		const height = $( this ).height();
		if ( width > maxWidth ) {
			maxWidth = width;
		}
		if ( height > maxHeight ) {
			maxHeight = height;
		}
	} );
	$( '.block-picker a' ).width( maxWidth );
	$( '.block-picker a' ).height( maxHeight );
	function setSelectedMonth( blockPicker, value ) {
		const submitButton = blockPicker
			.closest( 'form' )
			.find( '.wc-bookings-booking-form-button' );
		if ( undefined === value ) {
			SetButtonDisabled( submitButton, true );
			return;
		}
		const selectedBlock = blockPicker.find(
			'[data-value="' + value + '"]'
		);
		if ( undefined === selectedBlock.data( 'value' ) ) {
			SetButtonDisabled( submitButton, true );
			return;
		}
		blockPicker.closest( 'ul' ).find( 'a' ).removeClass( 'selected' );
		selectedBlock.addClass( 'selected' );
		SetButtonDisabled( submitButton, false );
	}
} );
